import React from 'react';
import { LenderStateConfigData } from '../../components/containers/lender-state-config-data';

export const Home = () => <LenderStateConfigData />;
